import { ThemeEvents, VariantUpdateEvent } from '@theme/events';
import { morph } from '@theme/morph';
import { Component } from '@theme/component';

class StoreAvailabilities extends Component {
  connectedCallback() {
    super.connectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.addEventListener(ThemeEvents.variantUpdate, this.updateAvailabilities);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    const closestSection = this.closest('.shopify-section, dialog');
    closestSection?.removeEventListener(ThemeEvents.variantUpdate, this.updateAvailabilities);
  }

  /**
   * @param {VariantUpdateEvent} event
   */
  updateAvailabilities = (event) => {
    if (event.detail.data.newProduct) {
      this.dataset.productId = event.detail.data.newProduct.id;
    } else if (event.target instanceof HTMLElement && event.target.dataset.productId !== this.dataset.productId) {
      return;
    }

    const newAvailabilities = event.detail.data.html.querySelector('store-availabilities');

    if (!newAvailabilities) return;

    morph(this, newAvailabilities, { childrenOnly: true });
  };
}

if (!customElements.get('store-availabilities')) {
  customElements.define('store-availabilities', StoreAvailabilities);
}
